import styles from "./Section.module.css";

interface Props {
  text: string;
  icon: React.ReactNode;
  color: string;
}

const Section = ({ text, icon, color }: Props): JSX.Element => {
  const style = {
    color,
  };

  return (
    <div style={style} className={styles.container}>
      <div className={styles.icon}>{icon}</div>
      <div className={styles.text}>{text}</div>
    </div>
  );
};

export default Section;
